// Phase 8C.6 — Accountability partner notification card.
//
// Shown inline when add_accountability_partner tool succeeds.
// Displays partner info, frequency, and confirmation.

import { Icon } from "../../../components/icons/Icon.tsx";

interface PartnerData {
  added?: boolean;
  partner_id?: string;
  partner_name?: string;
  partner_email?: string;
  frequency?: string;
  goal_title?: string;
  message?: string;
  error?: string;
}

const FREQ_LABELS: Record<string, string> = {
  daily: "Daily updates",
  weekly: "Weekly updates",
  milestone_only: "Milestone alerts only",
};

export function SikaPartnerCard({ data }: { data: unknown }): JSX.Element {
  const d = (data ?? {}) as PartnerData;

  if (d.error) {
    return (
      <div className="plan-card" style={{ borderColor: "var(--sika-negative, #C0392B)" }}>
        <div className="plan-head">
          <div className="label">Accountability Partner</div>
          <div className="ttl" style={{ color: "var(--sika-negative, #C0392B)" }}>Not Added</div>
          <div className="meta">{d.error}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="plan-card" style={{ borderColor: "var(--sika-positive, #27AE60)" }}>
      <div className="plan-head">
        <div className="label">Accountability Partner</div>
        <div className="ttl" style={{ fontFamily: "var(--sika-font-sans)", fontSize: "var(--sika-text-lg)" }}>
          Partner Added
        </div>
        {d.goal_title && <div className="meta">For: {d.goal_title}</div>}
      </div>

      <div className="plan-stats">
        <div className="stat-row">
          <span className="lbl" style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <Icon name="user" size={12} />
            Name
          </span>
          <span className="val">{d.partner_name ?? "—"}</span>
        </div>
        <div className="stat-row">
          <span className="lbl" style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <Icon name="mail" size={12} />
            Email
          </span>
          <span className="val">{d.partner_email ?? "—"}</span>
        </div>
        <div className="stat-row">
          <span className="lbl" style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <Icon name="clock" size={12} />
            Frequency
          </span>
          <span className="val">{FREQ_LABELS[d.frequency ?? "weekly"] ?? d.frequency}</span>
        </div>
      </div>

      <div className="plan-disclosure" style={{
        fontSize: "var(--sika-text-sm)",
        color: "var(--sika-text-secondary)",
        fontStyle: "italic",
      }}>
        {d.partner_name} will receive progress updates to keep you accountable.
      </div>
    </div>
  );
}
